  function accordeon() {
  $('#home-faq #accordion .panel-title a').click(function(){
    var $t = $(this);
    var $p = $t.parents('#accordion');
    var isClosed = $t.hasClass('collapsed');
    if(isClosed){
      if($p.find('.in').length){
        var $open = $p.find('.in');
        $open.slideUp( "300", function() {
          $open.removeClass('in');
        });
        $open.parents('.panel').find('.panel-title a').addClass('collapsed');
      }
      var $toOpen = $t.parents('.panel').find('.panel-collapse');
      $t.removeClass('collapsed');
      $toOpen.slideDown( "300", function() {
        $toOpen.addClass('in');
        $('.panel-body p').css('opacity','1');
      });

    }else{
      var $open = $p.find('.panel-collapse');
      $('.panel-body p').css('opacity','0');
      $open.slideUp( "slow", function() {
        $open.removeClass('in');
      });
      $open.parents('.panel').find('.panel-title a').addClass('collapsed');
    }
    return false;
  });
  }
  
  accordeon();
  
  jQuery(document).on('shopify:section:load', function(){  
    accordeon();
  });
  jQuery(document).on('shopify:block:select', function(){  
    accordeon();
  });
  jQuery(document).on('shopify:block:deselect', function(){  
    accordeon();
  });
